import { CanMatchFn, Route, UrlSegment, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../core/services/auth.service';

const buildUrl = (segments: UrlSegment[]) => '/' + segments.map(s => s.path).join('/');

// Auth guard: require presence of a token and redirect to login with returnUrl when missing
export const authGuard: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.token) return true;
  router.navigate(['/login'], { queryParams: { returnUrl: buildUrl(segments) } });
  return false;
};

// Role guard for CLIENT role
export const clientRoleGuard: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.token && auth.hasRole('CLIENT')) return true;
  if (!auth.token) router.navigate(['/login'], { queryParams: { returnUrl: buildUrl(segments) } });
  else router.navigate(['/']);
  return false;
};

// Role guard for ESTABLISHMENT role
export const establishmentRoleGuard: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.token && auth.hasRole('ESTABLISHMENT')) return true;
  if (!auth.token) router.navigate(['/login'], { queryParams: { returnUrl: buildUrl(segments) } });
  else router.navigate(['/']);
  return false;
};

// Role guard for EMPLOYEE role
export const employeeRoleGuard: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.token && auth.hasRole('EMPLOYEE')) return true;
  if (!auth.token) router.navigate(['/login'], { queryParams: { returnUrl: buildUrl(segments) } });
  else router.navigate(['/']);
  return false;
};

// Role guard for VALIDATION area (allow ESTABLISHMENT or EMPLOYEE)
export const validatorRoleGuard: CanMatchFn = (_route: Route, segments: UrlSegment[]) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.token && (auth.hasRole('ESTABLISHMENT') || auth.hasRole('EMPLOYEE'))) return true;
  if (!auth.token) router.navigate(['/login'], { queryParams: { returnUrl: buildUrl(segments) } });
  else router.navigate(['/']);
  return false;
};
